/* Home Background Art — relocates the wallpaper figure into the last
 * pre-footer funding strip and resizes the art band to span from the
 * hero bottom down to the end of MainContent.
 * Idempotent and reactive to Shopify section/block editor events.
 */
(() => {
  const setupHomeBackgroundArt = () => {
    const mainContent = document.querySelector('#MainContent');
    const artSection = document.querySelector('#MainContent > .shopify-section.section-home-background-art');
    if (!mainContent || !artSection) return;

    // Relocate the wallpaper figure into the last EU pre-footer strip so it
    // anchors to that section's bottom (and overflows upward) instead of
    // being pinned to MainContent's scroll bottom. The FEDER instance is
    // ordered last in index.json, so we grab the last match.
    const wallpaperFigure = artSection.querySelector('.ve-home-background-art__wallpaper');
    const preFooterStrips = document.querySelectorAll('.ve-pre-footer-funding-strip');
    const euSection = preFooterStrips[preFooterStrips.length - 1];
    if (wallpaperFigure && euSection && !euSection.contains(wallpaperFigure)) {
      euSection.appendChild(wallpaperFigure);
      euSection.classList.add('ve-pre-footer-funding-strip--has-wallpaper');
    }

    let rafId = null;

    const recalcBounds = () => {
      const mainRect = mainContent.getBoundingClientRect();
      const heroSection = mainContent.querySelector('.shopify-section.section-home-hero');

      const start = heroSection
        ? Math.max(0, heroSection.getBoundingClientRect().bottom - mainRect.top)
        : 0;
      const end = Math.max(start, mainContent.scrollHeight);

      artSection.style.top = `${start}px`;
      artSection.style.height = `${Math.max(0, end - start)}px`;
    };

    const scheduleRecalc = () => {
      if (rafId) cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(recalcBounds);
    };

    scheduleRecalc();
    window.addEventListener('load', scheduleRecalc, { passive: true });
    window.addEventListener('resize', scheduleRecalc, { passive: true });
    window.addEventListener('orientationchange', scheduleRecalc, { passive: true });
    document.addEventListener('shopify:section:load', scheduleRecalc);
    document.addEventListener('shopify:section:reorder', scheduleRecalc);
    document.addEventListener('shopify:section:select', scheduleRecalc);
    document.addEventListener('shopify:section:deselect', scheduleRecalc);
    document.addEventListener('shopify:block:select', scheduleRecalc);
    document.addEventListener('shopify:block:deselect', scheduleRecalc);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupHomeBackgroundArt, { once: true });
  } else {
    setupHomeBackgroundArt();
  }
})();
